import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlSettlementVoid } from './connectionData.tsx'

const useSettlementVoid = () => {
  const [errorSettlementVoid, setErrorSettlementVoid] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const settlementVoid = async (_id: string, cause: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSettlementVoid()
      const res = await customPost<{ message: string }>(apiUrl, { _id, cause, by })
      setErrorSettlementVoid(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSettlementVoid(err)
      } else {
        setErrorSettlementVoid(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorSettlementVoid, loading, settlementVoid }
}
export default useSettlementVoid
